<template>
  <div class="all_box">
    <div class="all_title">
      {{$t('base.shopBySports')}}
      <router-link :to="{path:'market?type=like'}" target="_blank">{{$t('base.seeAll')}}</router-link>
    </div>
    <div class="all_box">
      <div class="sports_box" :style="{'grid-template-columns':'repeat('+sportsCount+', 200px)'}">
        <router-link :to="{path:'/market',query:{type:item.PropertyName,id:item.PropertyValue,f:item.FirstCategoryId,s:item.SecondCategoryId,t:item.ThirdCategoryId}}" v-for="(item,index) in sports" :key="index" target="_blank" >
          <el-image class="sports_img" :src="item.IconUrl" fit="scale-down"></el-image>
          <span>{{ $store.state.lang != 'zh-tw'?item.EnName:item.ChName }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { CookiesCategory } from "@/api/public";
export default {
  name: 'footerNav',
  data() {
    return {
      sportsCount:12,
      sports: this.$enumInfo.PropertyList,
    }
  },
  mounted() {},
  created() {
    this.getMarketEntry()
  },
  methods: {
    getMarketEntry() {
      let that = this
      let fun = function(res) {
      //console.log("asares",res)
        that.sports = res
        that.sportsCount=Math.ceil(res.length/2);

      }
      //console.log("asasasasa",that.sports)
      CookiesCategory('get', 'cardCategory', 'entry', fun)
    },
    sportsWidth(){
    }

  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/home.css";
.sports_box{
  display: grid;
  overflow-x: auto;
}
.sports_box .sports_img {
  width: 65px;
}

</style>



// WEBPACK FOOTER //
// src/components/entry.vue